"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _makeQueryKey = _interopRequireDefault(require("../../../../../../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* istanbul ignore file */

var getWishlistSummaryQueryKey = function getWishlistSummaryQueryKey(_ref) {
  var listId = _ref.listId;
  return (0, _makeQueryKey["default"])(["/buy/wishlists/v2/lists/".concat(listId, "/items/summary")]);
};
var _default = exports["default"] = getWishlistSummaryQueryKey;